module.exports = __webpack_public_path__ + "img/D0008.2a1448eb.svg";